import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { studyOnboardingService } from "../../../APIServices/studyOnboarding";
import { useParams } from "react-router";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { dateStatus } from "../../../utils/universalFunction";
import Moment from "react-moment";

const EIWRSRecentActivity = ({StudyMode}) => {
  const { studyId } = useParams();
  const [rawIWRSActivity, setRawIWRSActivity] = useState([]);
  const [activityLoader, setActivityLoader] = useState(false);
  const [IWRSActivityCount, setIWRSActivityCount] = useState(0);

  const getStudyAllEIWRSAuditTrialList = async () => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAllEIWRSAuditTrialList(
      studyId,
      "recent",
      "eiwrs",
      StudyMode
    );
    setRawIWRSActivity(data?.data || []);
    setIWRSActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const IWRSActivity = useMemo(() => {
    const grouped = {};

    rawIWRSActivity.forEach((item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0];
      if (!grouped[date]) grouped[date] = [];

      grouped[date].push({
        module: item.category || "Unknown Module",
        type: item.actionType || "Unknown Type",
        activities: item.activities,
        mode: item.mode,
        activityByName: item.fullName,
        createdAt: item.createdAt,
      });
    });

    return Object.entries(grouped)
      .map(([date, data]) => ({
        date,
        data: data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [rawIWRSActivity]);

  function splitCamelCase(str) {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (char) => char.toUpperCase());
  }

  useEffect(() => {
    getStudyAllEIWRSAuditTrialList();
  }, [studyId, StudyMode]);

  return (
    <>
      {activityLoader ? (
        <PageLoader />
      ) : IWRSActivityCount === 0 ? (
        <NoDataFoundTable MSG={"Recent activity not found!"} />
      ) : (
        IWRSActivity?.map(({ date, data }, index) => (
          <div key={index}>
            <p className="p-2 m-0 position-sticky top-0 bg-body-secondary">
              {dateStatus(date)}
            </p>
            {data?.map((item, key) => (
              <div key={key} className="activity__section">
                <div className="w-100">
                  <ul className="m-0 p-0">
                    <li>
                      <p className="m-0 fontSize12 text-muted">
                        <span
                          className="text-capitalize"
                          style={{ fontWeight: 600 }}
                        >
                          {`${splitCamelCase(item.module)} (${item.type})`}:{" "}
                        </span>
                        {item.activities}
                      </p>
                    </li>
                  </ul>
                  <div className="mt-1 d-flex justify-content-between">
                    <Form.Label className="m-0 text-muted fontSize12">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </Form.Label>
                    <Form.Label className="m-0 text-muted fontSize12">
                       By: {item?.activityByName} <span className="fw-bold">({item?.mode})</span>
                    </Form.Label>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))
      )}
    </>
  );
};

export default EIWRSRecentActivity;
